module.exports = __webpack_public_path__ + "static/media/fair_4450.png.dfcc4c09.webp";